module.exports = __webpack_public_path__ + "static/img/11.fef57f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/11.png
// module id = 8hk9
// module chunks = 0